(function(){'use strict';
var BUILD='H02';
var script=document.currentScript;
var urls=[
  script&&script.getAttribute('data-fnx-s10'),
  script&&script.getAttribute('data-fnx-s11'),
  script&&script.getAttribute('data-fnx-h01'),
  script&&script.getAttribute('data-fnx-h02')
].filter(Boolean);
function reassert(){
  if(!document.body||!urls.length)return;
  var old=document.querySelectorAll('[data-fnx-cascade-authority]');
  for(var i=0;i<old.length;i++)old[i].remove();
  urls.forEach(function(href,index){
    var link=document.createElement('link');
    link.rel='stylesheet';
    link.href=href;
    link.setAttribute('data-fnx-cascade-authority','h02');
    link.setAttribute('data-fnx-authority-order',String(index+1));
    document.body.appendChild(link);
  });
  document.documentElement.setAttribute('data-fenix-cascade-authority',BUILD);
}
function badge(){
  document.documentElement.dataset.fenixBuild=BUILD;
  if(document.title.indexOf('['+BUILD+']')!==0){document.title='['+BUILD+'] '+document.title.replace(/^\[(?:S\d+[A-Z]?|H\d+)\]\s*/,'')}
  var old=document.getElementById('fnx-lab-build');if(old)old.remove();
  var el=document.createElement('div');
  el.id='fnx-lab-build';
  el.setAttribute('aria-label','FÉNIX hardening '+BUILD);
  el.textContent='FÉNIX LAB · H02 · SURFACE UNIFICATION · 25 AGO';
  el.style.cssText='position:fixed;left:10px;bottom:10px;z-index:2147483646;padding:7px 10px;border-radius:8px;background:#155dff;color:#eef6ff;font:700 10px/1.15 -apple-system,BlinkMacSystemFont,Segoe UI,sans-serif;letter-spacing:.08em;box-shadow:0 8px 24px rgba(0,0,0,.32),0 0 20px rgba(21,93,255,.25);pointer-events:none;text-transform:uppercase;';
  document.body.appendChild(el);
}
function settle(){reassert();badge();}
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',function(){setTimeout(settle,0)},{once:true});
}else{setTimeout(settle,0)}
window.addEventListener('load',function(){setTimeout(reassert,0)},{once:true});
})();